import React from 'react'
import Layout from "../../../../../../components/layouts/Layout";
import EditCareNotes from "../../../EditCareNotes";



function EditReviews() {
  return (
    <Layout pageTitleText="Notes">
    <div className="incidents consentCapacityAddNew">
      <div className="mainContent ">
        <div className="mainContentText">
          <h3>Edit Reviews note</h3>
          <EditCareNotes noteType="Reviews" parentListNoteUrl="/care-plan/general-notes" />
        </div>
      </div>
    </div>
  </Layout>
  )
}

export default EditReviews